import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  server: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/administrador/structure";
    this.token = this.auth.getToken();
  }

  getStructure(path: string) {
    const formData = new FormData();
    formData.append('path', path);
    return this.httpClient.post(this.server, formData);
  }

  newFolder(name: string){
    const formData = new FormData();
    formData.append('name', name);
    return this.httpClient.post(this.server+"/newfolder", formData);
  }

  deleteFolder(name: string){
    const formData = new FormData();
    formData.append('name', name);
    return this.httpClient.post(this.server+"/deletefolder", formData);
  }

  deleteFile(name: string){
    const formData = new FormData();
    formData.append('name', name);
    return this.httpClient.post(this.server+"/deletefile", formData);
  }

  upload(formData) {
    return this.httpClient.post<any>(this.server+"/upload", formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  download(path: string, name: string){
    const formData = new FormData();
    formData.append('file', path);
    return this.httpClient.post(this.server+"/download", formData,{responseType: 'blob' as 'json'});
  }

  downloadImage(id: number, tipo: string){
    const formData = new FormData();
    formData.append('registro', id.toString());
    formData.append('tipo', tipo);
    return this.httpClient.post(this.server+"/downloadimage", formData);
  }

  rename(oldName: string, newName: string){
    const formData = new FormData();
    formData.append('oldName', oldName);
    formData.append('newName', newName);
    return this.httpClient.post(this.server+"/rename", formData);
  }

  compress(directory: string, name: string) {
    const formData = new FormData();
    formData.append('directory', directory);
    formData.append('name', name);
    return this.httpClient.post(this.server+"/compress", formData);
  }

  copy(origen: string, destino: string) {
    const formData = new FormData();
    formData.append('origen', origen);
    formData.append('destino', destino);
    return this.httpClient.post(this.server+"/copy", formData);
  }

  move(origen: string, destino: string) {
    const formData = new FormData();
    formData.append('origen', origen);
    formData.append('destino', destino);
    return this.httpClient.post(this.server+"/move", formData);
  }

  getImageFromApi(imagen: string){
    const formData = new FormData();
    formData.append('imagen', imagen);
    return this.httpClient.post(this.server+"/getimage", formData);
  }

}
